"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_use_async_callback_1 = require("react-use-async-callback");
var useAccountService_1 = require("./useAccountService");
var useAuthenticatedState_1 = require("../../api/api-authorization/useAuthenticatedState");
var util_1 = require("util");
var useCache_1 = require("../../shared/useCache");
/**
 * Refresh the current user state using the accountService.
 * @param isAuthenticated
 */
var refreshCurrentUserRoles = function (isAuthenticated, accountService, setRoles) { return __awaiter(void 0, void 0, void 0, function () {
    var result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // Do nothing if we don't know our authentication state.
                if (util_1.isNullOrUndefined(isAuthenticated)) {
                    return [2 /*return*/];
                }
                // If we are not authenticated then we have no roles.
                if (!isAuthenticated) {
                    setRoles({ isAuthenticated: false, roles: [] });
                    return [2 /*return*/];
                }
                return [4 /*yield*/, accountService.currentUserRoles()];
            case 1:
                result = _a.sent();
                setRoles({ isAuthenticated: true, roles: result.roles });
                return [2 /*return*/];
        }
    });
}); };
/**
 * Returns the list of roles for the current user.
 */
function useCurrentUserRoles(options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var _a;
    var isAuthenticated = useAuthenticatedState_1.useAuthenticatedState().isAuthenticated;
    var _b = useCache_1.useCache('currentUserRoles'), roles = _b[0], setRoles = _b[1];
    var accountService = useAccountService_1.useAccountService();
    var _c = react_use_async_callback_1.useAsyncCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, refreshCurrentUserRoles(isAuthenticated, accountService, setRoles)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [accountService, isAuthenticated]), refresh = _c[0], _d = _c[1], isLoading = _d.isExecuting, errors = _d.errors;
    React.useEffect(function () {
        if (options.lazy) {
            return;
        }
        // Refresh from the store if we need to.
        if (util_1.isNullOrUndefined(isAuthenticated)) {
            return;
        }
        if (!roles || roles.isAuthenticated !== isAuthenticated) {
            refresh();
        }
    }, [refresh, options.lazy, isAuthenticated, roles]);
    // TODO handle options.pollInterval.
    return {
        data: { roles: (_a = roles === null || roles === void 0 ? void 0 : roles.roles) !== null && _a !== void 0 ? _a : null },
        refresh: refresh,
        isLoading: isLoading,
        errors: errors
    };
}
exports.useCurrentUserRoles = useCurrentUserRoles;
/**
 * Clear the cached user roles.
 */
function useResetCurrentUserRolesCallback() {
    var _this = this;
    var isAuthenticated = useAuthenticatedState_1.useAuthenticatedState().isAuthenticated;
    var _a = useCache_1.useCache('currentUserRoles'), setRoles = _a[1];
    var accountService = useAccountService_1.useAccountService();
    var refresh = react_use_async_callback_1.useAsyncCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, refreshCurrentUserRoles(isAuthenticated, accountService, setRoles)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [accountService, isAuthenticated])[0];
    return React.useCallback(function () {
        refresh();
    }, [refresh]);
}
exports.useResetCurrentUserRolesCallback = useResetCurrentUserRolesCallback;
//# sourceMappingURL=useCurrentUserRoles.js.map